import React from 'react';
import { BUY_VIGNNETTE_ROUTE } from 'constants/index';
import StepCard from 'components/StepCard';
import Title from 'components/Title';
import { Form, Upload, Row, Col, Alert } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import './styles.scss';

const { Dragger } = Upload;
let timer;

class UploadFiles extends React.Component {
  state = {};
  handleSubmit = e => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = new FormData();
        const documents = JSON.parse(sessionStorage.getItem('tarifChoices'));
        documents.documents.map(d => {
          data.append('documents[]', values[d].file.originFileObj);
        });
        this.props.uploadDocuments(data);
      }
    });
  };

  renderServerErrorMsg = () => {
    const { error } = this.props;
    if (error) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.setState({ visible: false });
      }, 5000);
      if (this.state.visible) {
        return (
          <div className="error-msg">
            <Alert description={error} type="error" />
          </div>
        );
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const documents = JSON.parse(sessionStorage.getItem('tarifChoices'));
    return (
      <Form onSubmit={this.handleSubmit}>
        <StepCard
          onPrevious={() =>
            this.props.updateRoute(BUY_VIGNNETTE_ROUTE.PERSONAL_DETAILS_ROUTE)
          }
          onNext={this.handleSubmit}
          current={3}
          steps={7}
          id="buy.vignete.instruction.title"
          className="buy-vignet-tarif-choices"
          isNextLoading={this.props.isLoading}
        >
          <Title id="upload.files" />
          <p>
            <FormattedHTMLMessage id="upload.files.instruction" />
          </p>
          <Row gutter={24} className="upload-wrapper">
            <Col
              span={24}
              xs={24}
              lg={24}
              md={24}
              sm={24}
              className="form-wrapper"
            >
              {documents.documents.map(data => {
                return (
                  <React.Fragment>
                    <h4>{data}</h4>
                    <Form.Item>
                      {getFieldDecorator(data, {
                        rules: [
                          {
                            required: true,
                            message: <FormattedMessage id="required.error" />,
                          },
                        ],
                      })(
                        <Dragger>
                          <p className="ant-upload-text">
                            <FormattedMessage id="upload.files.message" />
                            <a>
                              <FormattedMessage id="upload.files.select.files" />
                            </a>
                          </p>
                        </Dragger>,
                      )}
                      {data === 'Ligplaatsbewijs' && (
                        <p>
                          <FormattedHTMLMessage id="buy.vignet.upload.documents.lig.info" />
                        </p>
                      )}
                    </Form.Item>
                  </React.Fragment>
                );
              })}
              {this.renderServerErrorMsg()}
            </Col>
          </Row>
        </StepCard>
      </Form>
    );
  }
}

const UploadFilesForm = Form.create({ name: 'UploadFilesForm' })(UploadFiles);

export default UploadFilesForm;
